import React from 'react'
import PropTypes from 'prop-types'
import {
  StepperWrapper,
  StepContainer,
  StepCircle,
  StepLabel,
  StepConnector,
} from './styles'

export const DefaultStepper = ({ steps, activeStep, shape }) => {
  const clampedStep = Math.max(0, Math.min(activeStep, (steps || []).length - 1))

  if (!steps || steps.length === 0) return null

  return (
    <StepperWrapper>
      {steps.map((label, index) => {
        const completed = index < clampedStep
        const active = index === clampedStep
        return (
          <StepContainer key={`step-${index}`}>
            <StepCircle $shape={shape} $active={active} $completed={completed}>
              {completed ? '\u2713' : index + 1}
            </StepCircle>
            <StepLabel $active={active} $completed={completed}>
              {label}
            </StepLabel>
            {index < steps.length - 1 && (
              <StepConnector $completed={completed} />
            )}
          </StepContainer>
        )
      })}
    </StepperWrapper>
  )
}

DefaultStepper.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.string),
  activeStep: PropTypes.number,
  shape: PropTypes.oneOf(['circle', 'rounded']),
}

DefaultStepper.defaultProps = {
  steps: [],
  activeStep: 0,
  shape: 'circle',
}
